import { render } from "./MypageFileUpload.vue?vue&type=template&id=89536488"
import script from "./MypageFileUpload.vue?vue&type=script&lang=js"
export * from "./MypageFileUpload.vue?vue&type=script&lang=js"

import "./MypageFileUpload.vue?vue&type=style&index=0&id=89536488&lang=scss"

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__